"use strict";

/** Drag function */
(function (H) {

	function panDefault(proceed, e, panning) {
//var testdraglimit = $('.highcharts-annotation')[0].innerHTML.split('d="M')
		//console.log(testdraglimit[1].split(' ')[1])
		//console.log($('.highcharts-annotation-toolbar').is(":visible"))
		if($('.highcharts-annotation').length > 0  || $('.highcharts-annotation-toolbar').is(":visible")){
			return;
		}
		var chart = this,
		    hoverPoints = chart.hoverPoints,
		    doRedraw;

		if (hoverPoints) {
			H.each(hoverPoints, function (point) {
				point.setState();
			});
		}

		var mousePos = e['chartX'],
		    axisArr = chart.xAxis,
		    axis = axisArr[0],
		    startPos = chart['mouseDownX'],
		    halfPointRange = (axis.pointRange || 0) / 2,
		    newMin = axis.toValue(startPos - mousePos, true) + halfPointRange,
		    newMax = axis.toValue(startPos + chart['plotWidth'] - mousePos, true) - halfPointRange,

		mm = mmXaxis(chart),
		    allowedMax = mm.max,
		    allowedMin = mm.min;

		if (newMax > allowedMax) {
			newMax = allowedMax;
		}

		if (newMin <= allowedMin) {
			newMin = allowedMin;
		}

		for (var i = 0; i < axisArr.length; i++) {
			axisArr[i].setExtremes(newMin, newMax, false, false, { trigger: 'pan' });
		}

		doRedraw = true;

		chart['mouseDownX'] = mousePos; /* set new reference for next run */

		if (doRedraw) {
			chart.redraw(false);
		}
		H.css(chart.container, { cursor: 'move' });

		proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	};

	function mmXaxis(chart) {

		var min,
		    max,
		    xAxis = chart.xAxis,
		    i = 0,
		    len = xAxis.length;

		for (i = 0; i < len; i++) {
			var ax = xAxis[i],
			    dataMax = ax.dataMax,
			    dataMin = ax.dataMin;
			if (!max || dataMax > max) {
				max = dataMax;
			}
			if (!min || dataMin < min) {
				min = dataMin;
			}
		}

		return {
			min: min,
			max: max
		};
	};

	Highcharts.wrap(Highcharts.Chart.prototype, 'getChartHTML', function (proceed) {
		proceed.call(this);
		var l = this.series.length -1;
		$(".highcharts-series-"+l+"").remove();
		return this.container.innerHTML;
	});

	H.wrap(H.Chart.prototype, 'pan', function (proceed, e, panning) {
		// DEFAULT PANNING ACTIVITY, DON'T ALLOW FOR CRAZY ZOOM OUT ON PAN
		if (log) console.log("pan")
		var chart = this,
		    xAxis = chart.get('mainX'),
		    hoverPoints = chart.hoverPoints,
			doRedraw;

		if (typeof xAxis.ordinalPositions == 'undefined' || chart.series.length >= 3 || chart.prevType == "line" || chart.prevType == "area") {
			if (log) console.log('defaultPANE');
			return panDefault.apply(this, arguments);
		}

		/* remove active points for shared tooltip */
		if (hoverPoints) {
			H.each(hoverPoints, function (point) {
				point.setState();
			});
		}

		var mousePos = e['chartX'],
		    startPos = chart['mouseDownX'],
		    goingLeft = startPos > mousePos;

		var ordinalPositions = xAxis.ordinalPositions;
		var ordinalIndex = xAxis.ordinalIndex && xAxis.ordinalIndex.raw != undefined ? xAxis.ordinalIndex.raw : xAxis.ordinalPositions;

		var currentPos = {
			min: ordinalPositions[0],
			max: ordinalPositions[ordinalPositions.length - 1]
		};

		currentPos.minIndex = ordinalIndex.indexOf(currentPos.min);
		currentPos.maxIndex = ordinalIndex.indexOf(currentPos.max);

		var percentMoved = Math.abs(startPos - mousePos) / (xAxis.width / 100);

		var newMin,
		    newMax,
		    newMinIndex,
		    newMaxIndex,
		    numOfPoints = ordinalPositions.length,
		    axisArr = chart.xAxis;

		var pointsToMove = Math.ceil(percentMoved * numOfPoints / 100);

		if (goingLeft) {

			newMinIndex = currentPos.minIndex + pointsToMove;
			newMaxIndex = currentPos.maxIndex + pointsToMove;

			if (newMaxIndex >= ordinalIndex.length) {
				newMaxIndex = ordinalIndex.length - 1;
				newMinIndex = newMaxIndex - (numOfPoints - 1);
			}
		} else {

			newMinIndex = currentPos.minIndex - pointsToMove;
			newMaxIndex = currentPos.maxIndex - pointsToMove;

			if (newMinIndex < 0) {
				newMinIndex = 0;
				newMaxIndex = newMinIndex + numOfPoints - 1;
			}
		}

		newMin = ordinalIndex[newMinIndex];
		newMax = ordinalIndex[newMaxIndex];

		for (var i = 0; i < axisArr.length; i++) {
			axisArr[i].setExtremes(newMin, newMax, false, false, { trigger: 'pan' });
		}

		doRedraw = true;

		chart['mouseDownX'] = mousePos; /* set new reference for next run */

		if (doRedraw) {
			chart.redraw(false);
		}

		H.css(chart.container, { cursor: 'move' });

		proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	});
})(Highcharts);